// extracted by mini-css-extract-plugin
export default {"icon":"tooltip_icon-module___icon___b08f3631","textColor":"tooltip_icon-module___textColor___c5eac2ec"};